export const isTransitionComplete = (transition) => {
    return (transition.onboardingStatus === "LaunchComplete" &&
        transition.transitionPhase === "ReadyForHandoff");
};
//# sourceMappingURL=isTransitionComplete.js.map